import * as React from "react"
import { GatsbyImage } from "gatsby-plugin-image"

import Space from "./space"
import Text from "./text"
import TextRowClamp from "./text-row-clamp"
import Link from "./link"
import { ogDescription } from "../utils/article"
import { compareDate } from "../utils/date"

type Props = {
  title?: string
  displayIndex?: boolean
  articles?: any
  articleRecipes?: any
  articleReports?: any
  articleInterviews?: any
  articleUserInterviews?: any
}

const ArticleGridArticles: React.FC<Props> = ({
  title = "",
  displayIndex = false,
  articles = [],
  articleRecipes = [],
  articleReports = [],
  articleInterviews = [],
  articleUserInterviews = [],
}) => {
  const list: { article: any; to: string }[] = articles
    // @ts-ignore
    .map(article => {
      return { article, to: `/column/${article.slug}/` }
    })
    .concat(
      // @ts-ignore
      articleRecipes.map(article => {
        return { article, to: `/column/recipe/${article.slug}/` }
      })
    )
    .concat(
      // @ts-ignore
      articleReports.map(article => {
        return { article, to: `/column/report/${article.slug}/` }
      })
    )
    .concat(
      // @ts-ignore
      articleInterviews.map(article => {
        return { article, to: `/column/interview/${article.slug}/` }
      })
    )
    .concat(
      // @ts-ignore
      articleUserInterviews.map(article => {
        return { article, to: `/column/user-interview/${article.slug}/` }
      })
    )
    // @ts-ignore
    .sort((a, b) => {
      return compareDate(a.article.createdAt!, b.article.createdAt!)
    })

  const articleGridItem = ({
    article,
    to,
    index,
  }: {
    article: any
    to: string
    index: number
  }) => {
    return (
      <Link key={article.slug} to={to}>
        <div className="rounded-2xl shadow lg:rounded-none lg:shadow-none">
          <div className="relative">
            <GatsbyImage
              image={article.coverImage!.gatsbyImageData!}
              alt={article.coverImage!.title!}
              className="w-full rounded-t-2xl lg:rounded"
              imgClassName="w-full rounded-t-2xl lg:rounded"
            />
            {displayIndex && (
              <div className="absolute left-0 bottom-0 w-10 h-10 bg-black flex items-center justify-center">
                <Text fontBold={true} fontSize="lg" color="white">
                  {index + 1}
                </Text>
              </div>
            )}
          </div>
          <div className="p-3">
            <Text fontBold={true} fontSize="lg">
              {article.title}
            </Text>
            <Space sizeY="2" />
            <TextRowClamp clamp="2">
              <Text fontSize="sm">{ogDescription(article)}</Text>
            </TextRowClamp>
            <Space sizeY="3" />
          </div>
        </div>
        <Space sizeY="5" />
      </Link>
    )
  }

  return (
    <div>
      {title !== "" && (
        <>
          <Text fontSize="2xl" lgFontSize="3xl" fontBold={true}>
            {title}
          </Text>
          <Space sizeY="6" lgSizeY="8" />
        </>
      )}
      <div className="lg:grid lg:grid-cols-3 lg:gap-x-4 lg:gap-y-6">
        {list.map((ent, index) => {
          return articleGridItem({
            article: ent.article,
            to: ent.to,
            index,
          })
        })}
      </div>
    </div>
  )
}

export default ArticleGridArticles
